// This file should only contain action type constants.

// export const SET_FOO = 'SET_FOO';
export const SET_PROGRESS = 'SET_PROGRESS';
export const SET_TAB_LIST = 'SET_TAB_LIST';
export const SET_VEHICLE_ID = 'SET_VEHICLE_ID';
export const SET_PAGE_ALIAS = 'SET_PAGE_ALIAS';
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO';
export const SET_VEHICLE_INFO = 'SET_VEHICLE_INFO';
export const SET_WIDGET_CLASSES = 'SET_WIDGET_CLASSES';
export const SET_LOCALE = 'SET_LOCALE';



// WEBPACK FOOTER //
// ./src/actions/types.js